
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="header 自定义单元格" fileName="header-cell.md" />
        <demo-block>
        <div><p>1、<code>column</code>配置中，支持通过属性 <code>renderHeaderCell</code>传入渲染函数，与 body 自定义单元格用法一致。<code>renderHeaderCell</code>在表头分组中一样适用<br>2、渲染函数接收一个参数，<code>column</code>:当前列配置</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table
        style=&quot;width:100%&quot;
        border-y
        :columns=&quot;columns&quot;
        :table-data=&quot;tableData.filter(item=&gt;!searchText || item.name.toLowerCase().includes(searchText.toLowerCase()))&quot;
    /&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                columns: [
                    {
                        field: &quot;name&quot;,
                        key: &quot;a&quot;,
                        title: &quot;Name&quot;,
                        width: 200,
                        align: &quot;center&quot;,
                        renderHeaderCell: ({ column }, h) =&gt; {
                            return (
                                &lt;input
                                    // jsx 不能直接使用 v-model。此处为 jsx 实现 v-model，了解更多查看官方文档
                                    value={this.searchText}
                                    onInput={this.searchInputChange}
                                    style=&quot;width:90%&quot;
                                    placeholder=&quot;请输入名称关键字&quot;
                                /&gt;
                            );
                        },
                    },
                    {
                        field: &quot;date&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Date&quot;,
                        width: 200,
                        align: &quot;center&quot;,
                        renderHeaderCell: ({ column }, h) =&gt; {
                            return (
                                &lt;span class=&quot;text-bold&quot; style=&quot;color:#1890ff;&quot;&gt;
                                    {column.title}
                                &lt;/span&gt;
                            );
                        },
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        width: 300,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        width: &quot;&quot;,
                        align: &quot;left&quot;,
                    },
                ],
                tableData: [
                    {
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;coding&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        hobby: &quot;coding&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                    },
                ],
                // 搜索
                searchText: &quot;&quot;,
            };
        },
        methods: {
            // search input change event
            searchInputChange(e) {
                this.searchText = e.target.value;
            },
        },
    };
&lt;/script&gt;

&lt;style&gt;
    .text-bold {
        font-weight: bold;
    }
&lt;/style&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{staticStyle:{"width":"100%"},attrs:{"border-y":"","columns":_vm.columns,"table-data":_vm.tableData.filter(function (item){ return !_vm.searchText || item.name.toLowerCase().includes(_vm.searchText.toLowerCase()); })}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                columns: [
                    {
                        field: "name",
                        key: "a",
                        title: "Name",
                        width: 200,
                        align: "center",
                        renderHeaderCell: ({ column }, h) => {
                            return (
                                <input
                                    // jsx 不能直接使用 v-model。此处为 jsx 实现 v-model，了解更多查看官方文档
                                    value={this.searchText}
                                    onInput={this.searchInputChange}
                                    style="width:90%"
                                    placeholder="请输入名称关键字"
                                />
                            );
                        },
                    },
                    {
                        field: "date",
                        key: "b",
                        title: "Date",
                        width: 200,
                        align: "center",
                        renderHeaderCell: ({ column }, h) => {
                            return (
                                <span class="text-bold" style="color:#1890ff;">
                                    {column.title}
                                </span>
                            );
                        },
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        width: 300,
                        align: "left",
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        width: "",
                        align: "left",
                    },
                ],
                tableData: [
                    {
                        name: "John",
                        date: "1900-05-20",
                        hobby: "coding",
                        address: "No.1 Century Avenue, Shanghai",
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        hobby: "coding",
                        address: "No.1 Century Avenue, Beijing",
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                    },
                ],
                // 搜索
                searchText: "",
            };
        },
        methods: {
            // search input change event
            searchInputChange(e) {
                this.searchText = e.target.value;
            },
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      .text-bold {
        font-weight: bold;
    }
    </style>
  